export const stockImageFilterLegacyI18nMap = {
  ShutterStock_Filter_People_Model_Released: _TL_('People'),
  ShutterStock_Filter_People_Model_Released_True: _TL_('With a signed model release'),
  ShutterStock_Filter_People_Model_Released_False: _TL_('Without a signed model release'),
  ShutterStock_Filter_People_Ethnicity: _TL_('Ethnicity'),
  ShutterStock_Filter_People_Ethnicity_African: _TL_('African'),
  ShutterStock_Filter_People_Ethnicity_African_American: _TL_('African American'),
  ShutterStock_Filter_People_Ethnicity_Black: _TL_('Black'),
  ShutterStock_Filter_People_Ethnicity_Brazilian: _TL_('Brazilian'),
  ShutterStock_Filter_People_Ethnicity_Chinese: _TL_('Chinese'),
  ShutterStock_Filter_People_Ethnicity_Caucasian: _TL_('Caucasian'),
  ShutterStock_Filter_People_Ethnicity_East_Asian: _TL_('East Asian'),
  ShutterStock_Filter_People_Ethnicity_Hispanic: _TL_('Hispanic'),
  ShutterStock_Filter_People_Ethnicity_Japanese: _TL_('Japanese'),
  ShutterStock_Filter_People_Ethnicity_Middle_Eastern: _TL_('Middle Eastern'),
  ShutterStock_Filter_People_Ethnicity_Native_American: _TL_('Native American'),
  ShutterStock_Filter_People_Ethnicity_Pacific_Islander: _TL_('Pacific Islander'),
  ShutterStock_Filter_People_Ethnicity_South_Asian: _TL_('South Asian'),
  ShutterStock_Filter_People_Ethnicity_Southeast_Asian: _TL_('Southeast Asian'),
  ShutterStock_Filter_People_Ethnicity_Other: _TL_('Other'),
  ShutterStock_Filter_People_Gender: _TL_('Gender'),
  ShutterStock_Filter_People_Male: _TL_('Male'),
  ShutterStock_Filter_People_Female: _TL_('Female'),
  ShutterStock_Filter_People_Both: _TL_('Both'),
  ShutterStock_Filter_People_Age: _TL_('Age'),
  ShutterStock_Filter_People_Age_Infants: _TL_('Infants'),
  ShutterStock_Filter_People_Age_Children: _TL_('Children'),
  ShutterStock_Filter_People_Age_Teenagers: _TL_('Teenagers'),
  ShutterStock_Filter_People_Age_20s: _TL_('20s'),
  ShutterStock_Filter_People_Age_30s: _TL_('30s'),
  ShutterStock_Filter_People_Age_40s: _TL_('40s'),
  ShutterStock_Filter_People_Age_50s: _TL_('50s'),
  ShutterStock_Filter_People_Age_60s: _TL_('60s'),
  ShutterStock_Filter_People_Age_Older: _TL_('Older'),
  ShutterStock_Filter_People_Number: _TL_('Number of people'),
  ShutterStock_Filter_Filter: _TL_('Filter'),
  ShutterStock_Filter_Reset: _TL_('Reset'),
  ShutterStock_Filter_Apply: _TL_('Apply'),
  Filter_PredicateList_New: _TL_('Add another'),
  Filter_Validation_Common_Required: _TL_('Required field'),
  Filter_Validation_Common_Number: _TL_('Only numeric values allowed'),
  Filter_Validation_Common_Number_Range: _TL_('Numeric value out of allowed range'),
  Filter_Validation_Common_Integer: _TL_('Only integer values allowed'),
  Filter_Validation_EnumSelectionRequired: _TL_('Select at least one option'),
  Filter_Validation_Common_Date: _TL_('Incorrect date format'),
  ShutterStock_Filter_Operator_Eq: _TL_('is'),
  ShutterStock_Filter_People_Age_Children_X: _TL_('Children ', { comment: 'kids, not adults; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_20s_X: _TL_('20s ', { comment: 'a person about 20 years old; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_30s_X: _TL_('30s ', { comment: 'a person about 30 years old; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_40s_X: _TL_('40s ', { comment: 'a person about 40 years old; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_50s_X: _TL_('50s ', { comment: 'a person about 50 years old; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_60s_X: _TL_('60s ', { comment: 'a person about 60 years old; This is one of people age options on UI; please note there is a space trail' }),
  ShutterStock_Filter_People_Age_Older_X: _TL_('Older ', { comment: 'a more older person, maybe > 60 years old; This is one of people age options on UI; please note there is a space trail' }),
};
